exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".table-header {\n  width: 100%;\n}\n.table-header .filter-box {\n  width: 100% !important;\n  margin-bottom: 10px !important;\n}\n.table-header .btns button {\n  margin-right: 16px;\n}\n", ""]);

